// WhatsApp number in international format, digits only.
export const WHATSAPP = "233530485235";

// Fill in the `url` for each profile you have. Empty urls are hidden automatically.
export const SOCIALS = [
  { key: "facebook", label: "Facebook", url: "https://www.facebook.com/ygorganicinputs" },
  { key: "instagram", label: "Instagram", url: "https://www.instagram.com/ygorganicinputs" },
  { key: "linkedin", label: "LinkedIn", url: "" },
  { key: "twitter", label: "X (Twitter)", url: "" },
  { key: "youtube", label: "YouTube", url: "" },
  { key: "tiktok", label: "TikTok", url: "https://www.tiktok.com/@yayra_glover_organic_inp" },
];

export const activeSocials = () => SOCIALS.filter((s) => s.url);
